import fetch from "cross-fetch";
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";

// Create error link to handle CORS fallback
const corsErrorLink = onError(({ networkError }) => {
  if (networkError) {
    // Check if it's a CORS error
    const isCorsError =
      networkError.message?.includes("CORS") ||
      networkError.message?.includes("Failed to fetch") ||
      networkError.name === "TypeError";

    // Only redirect if we're on the bare domain
    if (
      isCorsError &&
      typeof window !== "undefined" &&
      window.location.hostname === "chikitea.com"
    ) {
      console.warn(
        "CORS error detected on chikitea.com, redirecting to www.chikitea.com..."
      );
      const newUrl =
        "https://www.chikitea.com" +
        window.location.pathname +
        window.location.search +
        window.location.hash;
      window.location.replace(newUrl);
    }
  }
});

const httpLink = new HttpLink({
  uri: process.env.GATSBY_STRAPI_API_URL + "/graphql",
  fetch,
});

export const client = new ApolloClient({
  link: ApolloLink.from([corsErrorLink, httpLink]),
  cache: new InMemoryCache(),
});
